/* NordicHigh kollektionsgrid (2/9-2026): quick-add til SlideCartHQ + pile til
   bestseller-karrusellen i kollektions-headeren (pilene skjules automatisk,
   naar alle produkter allerede er synlige).
   Indlaeses med defer fra sections/feature-collection-grid.liquid (kan forekomme
   flere gange pr. side -> guard). Vanilla JS, ingen dependencies. */
(function () {
  if (window.__nhCollectionInit) return;
  window.__nhCollectionInit = true;

  function syncArrows() {
    document.querySelectorAll('.nh-chero3__scroller').forEach(function (sc) {
      var track = sc.querySelector('[data-nh-track]');
      var arrows = sc.querySelector('.nh-chero3__arrows');
      if (track && arrows) {
        arrows.style.display = track.scrollWidth > track.clientWidth + 4 ? '' : 'none';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncArrows);
  } else {
    syncArrows();
  }
  window.addEventListener('resize', syncArrows);

  document.addEventListener('click', function (e) {
    /* Karrusel-pile i kollektions-headeren */
    var arrow = e.target.closest('[data-nh-arrow]');
    if (arrow) {
      var scroller = arrow.closest('.nh-chero3__scroller');
      var track = scroller && scroller.querySelector('[data-nh-track]');
      if (track) {
        var dir = Number(arrow.getAttribute('data-nh-arrow')) || 1;
        track.scrollBy({ left: dir * track.clientWidth * 0.7, behavior: 'smooth' });
      }
      return;
    }

    var btn = e.target.closest('.nh-quick-add');
    if (!btn || btn.disabled || btn.classList.contains('is-loading') || btn.classList.contains('is-done')) return;
    e.preventDefault();

    var variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId) return;

    var label = btn.querySelector('.nh-atc__label');
    var originalText = label ? label.textContent : '';

    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        if (label) label.textContent = 'Tillagd';
        try {
          if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
          if (typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
        } catch (err) { /* skuffen mangler -> knappen viser stadig Tilfoejet */ }
        setTimeout(function () {
          btn.classList.remove('is-done');
          if (label) label.textContent = originalText;
        }, 1600);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        if (label) label.textContent = originalText;
        /* Fallback: gaa til produktsiden, saa kunden aldrig staar fast */
        var card = btn.closest('.nh-card');
        var link = card && card.querySelector('a.nh-card__media');
        if (link && link.href) window.location.href = link.href;
      });
  });
})();
